import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9374ec74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "x-modal x-modal__scrapepath-setting"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "x-modal__container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x-modal__header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "x-modal__title" }, " 来源管理 ")
], -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "loading-box" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "exception" }
const _hoisted_9 = { class: "exception-detail" }
const _hoisted_10 = { class: "exception-title" }
const _hoisted_11 = { class: "exception-subtitle" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "section-title" }
const _hoisted_14 = { class: "radio-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-meta" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "radio-label" }, [
    /*#__PURE__*/_createElementVNode("span", null, "全部目录"),
    /*#__PURE__*/_createElementVNode("span", { class: "radio-tag" }, "懒人推荐")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "radio-desc" }, " 将读取内置磁盘、外接硬盘、Samba等全部存储路径 ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-meta" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "radio-label" }, [
    /*#__PURE__*/_createElementVNode("span", null, "自定义目录"),
    /*#__PURE__*/_createElementVNode("span", { class: "radio-tag" }, "个性私密")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "radio-desc" }, " 仅读取特定文件夹 ")
], -1))
const _hoisted_17 = { class: "plus-icon" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加目录", -1))
const _hoisted_19 = { class: "scrapepath-table" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "位置"),
  /*#__PURE__*/_createElementVNode("span", null, "操作")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-icon" }, null, -1))
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "item-operations" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "popover-container" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popover-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icomoon-icon icomoon-warn popover-header-icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "popover-title" }, "确定要移除目录？")
], -1))
const _hoisted_27 = { class: "popover-content" }
const _hoisted_28 = { class: "popover-footer" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-image" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-description" }, " 暂未添加任何目录 ", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 0,
  class: "x-modal__footer"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-close icon-close" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]

import { reactive, computed, onMounted, ref } from 'vue'
import XPopover from '@remote/components/Popover.vue'
import SVGIcon from '@remote/components/SVGIcon.vue'
import Loading from '@remote/components/Loading.vue'
import Modal from '@remote/components/modal'
import { extractUUID } from './helper'
import { checkState } from '@remote/store/utils'
import { transformPath } from '@remote/utils/cinema'
import type { IPathPickerResult } from './type'

interface IProps {
  mutex?:boolean
  mask?: boolean
  closeOnMaskClick?: boolean
  subtitle:string
  isLoading:boolean
  error: {type: string; hint?: string}
  isScrapeAll:boolean
  isEmpty:boolean
  list:any[]
  close:Function
  refresh:Function
  addPath:Function
  deletePath:Function
  toggleScrapeAll:Function
}


export default /*#__PURE__*/_defineComponent({
  props: {
    mutex: { type: Boolean },
    mask: { type: Boolean, default: true },
    closeOnMaskClick: { type: Boolean, default: false },
    subtitle: null,
    isLoading: { type: Boolean, default: false },
    error: null,
    isScrapeAll: { type: Boolean },
    isEmpty: { type: Boolean },
    list: null,
    close: null,
    refresh: null,
    addPath: null,
    deletePath: null,
    toggleScrapeAll: null
  },
  setup(__props: any) {

const props = __props as { mutex?:boolean, mask: boolean, closeOnMaskClick: boolean, subtitle:string, isLoading:boolean, error: {type: string; hint?: string}, isScrapeAll:boolean, isEmpty:boolean, list:any[], close:Function, refresh:Function, addPath:Function, deletePath:Function, toggleScrapeAll:Function }

function spellPathName (dir: string, name: string) {
  return `${dir}/${name}`.replace(/^\//, '')
}



const isMount = ref(true)
function onClose () {
  isMount.value = false
  props.close(null)
}

function onMaskClick () {
  if (!props.closeOnMaskClick) return
  onClose()
}

const hasError = computed(() => !!props.error.type)
const exception = computed(() => {
  switch (props.error.type) {
    case 'networkOffline': {
      return {
        icon: 'network-offline',
        title: '没有网络',
        subtitle: '请稍后重试',
        btnText: '点击重试',
      }
    }
    case 'noData': {
      return {
        icon: 'empty',
        title: '添加视频所在文件夹到个人片库吧～',
        subtitle: '',
        btnText: '',
      }
    }
    case 'notFound': {
      return {
        icon: 'not-found',
        title: '服务请求超时',
        subtitle: '请稍后重试',
        btnText: '点击重试',
      }
    }
    case 'timeout': {
      return {
        icon: 'error',
        title: '服务请求超时',
        subtitle: '请稍后重试',
        btnText: '点击重试',
      }
    }
    case 'someError': {
      return {
        icon: 'error',
        title: '出错了～',
        subtitle: error.value.hints || '',
        btnText: '点击重试',
      }
    }
    default: {
      return {
        icon: 'error',
        title: '出错了～',
        subtitle: error.value.hints || '',
        btnText: '',
      }
    }
  }
})
const isScrapeAll = computed(() => props.isScrapeAll)

function onToggleScrapeAllSwitch (isAll: boolean) {
  hidePopover()
  if (props.isScrapeAll === isAll) return
  if (checkState(true)) return
  props.toggleScrapeAll(isAll)
}

const currPopover = reactive({
  tag: '',
  submitting: false,
  errorText: '',
  style: {},
})
function showPopover (id: string, evt: MouseEvent) {
  if (props.isScrapeAll) return
  currPopover.tag = id
  currPopover.errorText = ''
  currPopover.submitting = false
  currPopover.style = {}
  const iconEl = evt.target as HTMLSpanElement
  if (iconEl) {
    const rect = iconEl.getBoundingClientRect()
    currPopover.style = {
      position: 'fixed',
      left: (rect.left + rect.width) + 'px',
      top: (rect.top - 8) + 'px',
      right: 'unset',
      bottom: 'unset',
      zIndex: 11,
      transform: 'translate(-100%, -100%)',
    }
  }
}
function hidePopover () {
  currPopover.tag = ''
  currPopover.errorText = ''
  currPopover.submitting = false
  currPopover.style = {}
}

function onDelete (pid: string) {
  if (props.mutex && props.isScrapeAll) return
  if (checkState(true, false, false, true)) {
    currPopover.errorText = '网络异常，请检查网络'
    return
  }
  currPopover.submitting = true
  props.deletePath(pid).then(() => {
    hidePopover()
  }).finally(() => {
    if (currPopover.tag === pid) {
      currPopover.submitting = false
    }
  })
}

function triggerAddScrapePath (evt: MouseEvent) {
  evt.stopPropagation()
  if (props.mutex && isScrapeAll.value) return
  if (checkState(true)) return
  // pathSelectorStore.toggleVisibleSelectFolder(true)
  Modal.showHeziMulPathSelector({
    mask: true,
    closeOnMaskClick: false,
    onConfirm: onAddScrapePath,
  })
}

function onAddScrapePath (paths: Array<Pick<IPathPickerResult, 'id' | 'path' | 'diskName'>>) {
  const list = paths.map(path => {
    const isInternal = path.diskName === '内置磁盘'
    const uuid = extractUUID(path.path)
    const diskPath = isInternal ? `/xos_storage/v1/${uuid}` : ''
    const item: Pick<IPathPickerResult, 'path' | 'diskName'> = {
      diskName: path.diskName,
      path: !isInternal ? path.path : path.path.replace(diskPath, '').replace(/^\/+/, ''),
    }
    return item
  })
  return props.addPath(list.map(p => {
    return {
      path: p.path,
      disk_name: p.diskName,
    }
  }))
}

function onRetry () {
  props.refresh()
}

onMounted(() => {
  if (hasError.value) {
    // 如果上次处于异常状态，再次打开时自动重试
    onRetry()
  }
})

return (_ctx: any,_cache: any) => {
  return (isMount.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.mask)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "x-modal__mask",
              onClick: _withModifiers(onMaskClick, ["self"])
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: _normalizeClass(["x-modal__content", { 'is-ready': !props.isLoading && !_unref(hasError) }])
          }, [
            (props.isLoading)
              ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(Loading, { class: "loading-text" })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(hasError))
              ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["exception-img", _unref(exception).icon])
                    }, null, 2),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(exception).title), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(exception).subtitle), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "exception-button",
                      onClick: onRetry
                    }, " 点击重试 ")
                  ])
                ]))
              : _createCommentVNode("", true),
            (!props.isLoading && !_unref(hasError))
              ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(props.subtitle), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "radio",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (onToggleScrapeAllSwitch(true)))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["radio-icon", [props.isScrapeAll ? 'checked' : 'uncheck']])
                      }, null, 2),
                      _hoisted_15
                    ]),
                    _createElementVNode("div", {
                      class: "radio",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onToggleScrapeAllSwitch(false)))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["radio-icon", [!props.isScrapeAll ? 'checked' : 'uncheck']])
                      }, null, 2),
                      _hoisted_16,
                      _createElementVNode("button", {
                        class: _normalizeClass(["radio-extra", { 'forbidden': __props.mutex && props.isScrapeAll }]),
                        onClick: triggerAddScrapePath
                      }, [
                        _createElementVNode("span", _hoisted_17, [
                          _createVNode(SVGIcon, {
                            name: "plus",
                            style: { pointerEvent: 'none' }
                          })
                        ]),
                        _hoisted_18
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    (!props.isEmpty)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_20,
                          _createElementVNode("ul", {
                            class: _normalizeClass(["scrapepath-list", { 'forbidden': __props.mutex && props.isScrapeAll }])
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: item.id,
                                class: _normalizeClass(["scrapepath-item", { 'is-special': item.path.replace(/^\.\//, '') === '我的下载' }])
                              }, [
                                _hoisted_21,
                                _createElementVNode("p", {
                                  class: "item-title",
                                  title: spellPathName(item.dir, item.name)
                                }, _toDisplayString(_unref(transformPath)(spellPathName(item.dir, item.name))), 9, _hoisted_22),
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(XPopover, {
                                    visible: _unref(currPopover).tag === item.id,
                                    align: "top-right",
                                    disabled: _unref(currPopover).tag !== item.id,
                                    "overlay-position": "fixed",
                                    "overlay-style": _unref(currPopover).style,
                                    onClose: hidePopover
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: "item-operation del-icon",
                                        onClick: ($event: any) => (showPopover(item.id, $event))
                                      }, [
                                        _createVNode(SVGIcon, {
                                          name: "trash",
                                          style: { pointerEvent: 'none' }
                                        })
                                      ], 8, _hoisted_24)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_25, [
                                        _hoisted_26,
                                        _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(currPopover).errorText), 1),
                                        _createElementVNode("div", _hoisted_28, [
                                          _createElementVNode("button", {
                                            class: "popover-button impt",
                                            onClick: ($event: any) => (onDelete(item.id))
                                          }, " 移除 ", 8, _hoisted_29),
                                          _createElementVNode("button", {
                                            class: "popover-button light",
                                            onClick: hidePopover
                                          }, " 暂不 ")
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["visible", "disabled", "overlay-style"])
                                ])
                              ], 2))
                            }), 128))
                          ], 2)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["empty-table", { 'forbidden': __props.mutex && props.isScrapeAll }])
                        }, _hoisted_32, 2))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          (!__props.isLoading && !_unref(hasError))
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", { class: "operations" }, [
                  _createElementVNode("button", {
                    class: "operation impt",
                    onClick: onClose
                  }, " 确定 "),
                  _createElementVNode("button", {
                    class: "operation light",
                    onClick: onClose
                  }, " 取消 ")
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "x-modal__close",
            onClick: onClose
          }, _hoisted_35)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})